import config from "../../../config";
import kebabCase from 'lodash/kebabCase';
import styles from './Post.module.scss';
import Helmet from 'react-helmet';
import React from 'react';
import { slugs, strings } from '../../utils/localization';
import StateLink from '../StateLink';
import { MDXRenderer } from "gatsby-plugin-mdx"
import ShareDialog from '../Layout/ShareDialog'; // TODO flytta sharedialog
import Img from "gatsby-image"
import Chip from '../Chips/Chip'
import Audio from '../Audio'

const Post = ({ post, pageTitle, location }) => {
    const {
        title,
        author,
        tags,
    } = post.frontmatter;

    const {
        image,
        audio
    } = post.fields;
    
    const { body, tableOfContents, excerpt } = post;

    const stripTrailingSlash = (str) => {
        return str.endsWith('/') ?
            str.slice(0, -1) :
            str;
    };

    return (
        <>
            <Helmet>
                <html lang={strings.htmlLang} />
                <title>{pageTitle}</title>
                <meta name="description" content={excerpt} />
                <meta name="og:title" content={pageTitle} />
                <meta name="og:description" content={excerpt} />
                <meta name="og:type" content="book" />
                <meta name="og:url" content={config.url} />
                <meta name="og:image" content={`https://fagelaventyret.netlify.com${image ? image.childImageSharp.fixed.src : ''}`} />
                <meta name="book:author" content={`${config.url}${slugs.authors}${author.toLowerCase()}/`} />
            </Helmet>
            <div className={styles.introcontainer}>
                <Img className={styles.fluid} fluid={image.childImageSharp.fluid} />
                <h1 className={styles.fluidTitle}>{title}</h1>
                <StateLink to={`${slugs.authors}${kebabCase(author)}/`}>
                    <div className={styles.author}>{author}</div>
                </StateLink>
            </div>
            {tableOfContents && tableOfContents.items && tableOfContents.items.length > 0 &&
                <div className={styles.tableOfContents} >
                    <ul>
                        {tableOfContents.items.map(x =>
                            <li key={x.title}>
                                <StateLink to={`${stripTrailingSlash(location.pathname)}${x.url}`}>
                                    {x.title}
                                </StateLink>
                            </li>
                        )}
                    </ul>
                </div>
            }
            <ShareDialog />
            <Audio audio={audio.publicURL} />
            <div className={styles.family}>
                <StateLink to={`/familjer/${kebabCase(tags[0])}/`}>
                    <Chip className={styles.chip} label={`Familj: ${tags[0]}`} />
                </StateLink>
            </div>
            <div className={styles.story} style={location.state && location.state.iStoriez ? undefined : { paddingBottom: "60px" }}>
                <MDXRenderer>{body}</MDXRenderer>
            </div>
        </>
    );
};

export default Post;
